<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2">
            <app-navbar></app-navbar>
        </div>
        <div class="col-lg-10">
            <div class="row">
                <div class="col-lg-9">
                    <br>
                    <h2>Alertas de Grupos</h2>
                </div>
            </div>

            <table class="table table-striped center">
                <thead>
                    <tr>
                        <td>Grupo</td>
                        <td>Fecha de registro</td>
                        <td>Clientes totales</td>
                        <td>Clientes con anticipo</td>
                        <td>% de clientes con anticipo</td>
                        <td>Días desde Registro</td>
                        <td>Estado 1</td>
                        <td>Estado 2</td>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let grupo of grupos">
                        <td>{{grupo.grupo}}</td>
                        <td>{{grupo.fecha_registro}}</td>
                        <td>{{grupo.usuariosGrupo}}</td>
                        <td>{{grupo.usuariosAnticipo}}</td>
                        <td>{{grupo.porcentajeConAnticipo}} %</td>
                        <td>{{grupo.diferenciaDias}}</td>
                        <td>
                            <div *ngIf="grupo.estado == '0'">
                                <span class="rojo bold">Alerta</span>
                            </div>
                            <div *ngIf="grupo.estado == '1'">
                                <span class="verde bold">OK</span>
                            </div>
                        </td>
                        <td>
                            <div *ngIf="grupo.estado2 == '0'">
                                <span class="rojo bold">Alerta</span>
                            </div>
                            <div *ngIf="grupo.estado2 == '1'">
                                <span class="verde bold">OK</span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>